module.exports = __webpack_public_path__ + "static/media/bbox-labeling.9e5e9969.gif";